import React from 'react';

/** Pencil / edit icon; inherits color via `currentColor` (greyscale via parent). */
const PencilIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M17 3a2.828 2.828 0 1 1 4 4L7 19l-4 1 1-4L17 3z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PencilIcon;
